import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import DashboardIngunzioneService from "./detailIngiunzioneService";
import { Form, InputGroup, Modal, Button, Row, Col, Table } from "react-bootstrap";
import { BsFillCircleFill } from "react-icons/bs";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
  capitalizeFirstLetter,
  geDataFormatFirst,
  getFormatOraInput,
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import DetailIngiunzioneService from "./detailIngiunzioneService";
import { validEmail, validPassword } from "../../../common/utils";
import R from "../../detail/detailSanzione/letter-r.png";

const pdfMake = require('pdfmake/build/pdfmake');
const pdfFonts = require('pdfmake/build/vfs_fonts');
class Ingiunzione extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      impostazioniSpese: [],
      valoretotaleImpostazioniIngiunzione:0,
      showModalRateizzaSanzione: false,
      fieldIndirizzoMail: "",
      showModalInvioMail: false,
      disableInput: true,
      showModalSanzioniRecidivo: false,
      loading: false,
      isErrorEmail: true,
      showModalStoricoPagamenti:false,
      storicoPagamenti:[],
      confermaUlteriorreDiunPagamento: true,
      statiSanzione: [],
      importoInferiroDellaSanzioneDiUnPagamento: true,
      tableRata: [],
      showModalStoricoSanzione: false,
      showModalAgliAttiScrittoDifensivo: false,
      agliAttiScrittoDifensivo: true,
      agliAttiNota: "",
      showModalRateDaPagare: false,
      paga: {
        numeroSanzione: "",
        dataContabile: getFormatOraInput(new Date()),
        tipoPagamento: "0",
        importoNetto: 0,
        codiceTx: "",
        note: "",
        numeroRata: "",
      },
      creaRata: {
        numeroDiRata: 0,
        SpeseIncassoRata: "",
      },
      rata: {
        numeroSanzione: "",
        rate: [
          {
            id: 0,
            numeroRata: "",
            importo: "",
            dataScandenza: "",
            stato: "",
            spesaIncassoRata: "",
          },
        ],
      },
      rowSanzionePrev: {
        idSaznioneProvenienza: 0,
        numeroSanzioneProvenienza: "",
      },
      recidivo: [
        {
          nome: "",
          cognome: "",
          cf: "",
          nSanz: 0,
          listaDiDettaglioSanzioni: [
            {
              numSanzione: "",
              dataEmissione: 0,
              statoSanzione: "",
              idSanzione: 0,
            },
          ],
        },
      ],
      sanzione: {
        idSanzione: 0,
        importoIngiunzione: 0,
        dataCreazioneIngiunzione: 0,
        numeroSanzione: "",
        protocolloSanzione: "",
        matricolaControllore: "",
        importoSanzione: 0,
        dataDiEmissioneSanzione: 0,
        annotazioneControllore: "",
        isverbaleFattoABordo: 0,
        spacchettatoDTO:{
          listaSpacchettatiIntero:[],
        }
      },
      dettaglioSanzione: {
        idSanzione: "",
        matricolaControllore: "",
        dataDiEmissione: "",
        importo: "",
        anagraficaTrasgressore: {
          nome: "",
          cognome: "",
          dataDiNascita: "",
          luogoDiNascita: "",
          isMinorenne: false,
          numeroDocumento: "",
          dataRilascioDocumento: "",
          comuneDiResidenza: "",
          inidirizzoDiResidenza: "",
          inidirizzoNumeroDiResidenza: "",
          frazione: "",
          provinciaDiResidenza: "",
          capDiResidenza: "",
          codiceFiscale: "",
        },
        anagraficaPotestaTrasgressore: {
          nome: "",
          cognome: "",
          dataDiNascita: "",
          luogoDiNascita: "",
          isMinorenne: false,
          numeroDocumento: "",
          dataRilascioDocumento: "",
          comuneDiResidenza: "",
          inidirizzoDiResidenza: "",
          inidirizzoNumeroDiResidenza: "",
          frazione: "",
          provinciaDiResidenza: "",
          capDiResidenza: "",
          codiceFiscale: "",
        },
        anagraficaTipologiaSanzione: {
          nomeViolazione: "",
          speseProcedura: 0,
          idAnagrafiaTipolagiaSanzione: 0,
          importoRidotto: 0,
          aggiungiPrezzoTratta: 0,
        },
        anagraficaStati: {
          nomeStato: "",
        },

        // tratta:{
        //     origine:'',
        //     destinazione:'',
        //     prezzo:''
        // },
        localita: {
          nomeLocalita: "",
        },
        violazione: "",
        isverbaleFattoABordo: false,
        annotazioneAgenteDichiarazioneTrasgressore: "",
      },
      valoreProv: 0,
      path: "",
      pathPush: "",
      loadingButton:false,
    };
  }

  componentDidMount() {
    this.detailIngiunzioneService = new DetailIngiunzioneService();

    this.detailIngiunzioneService.impostazioniSpese((result) => {
      // console.log(result);
      this.state.impostazioniSpese = result;
    });

    var idIngiunzione = JSON.parse(sessionStorage.getItem("rowIngiunzione"));
    this.state.path =
      idIngiunzione.statoSanzione === "IngiunzioneAperta"
        ? "Ingiunzione Aperta"
        :idIngiunzione.statoSanzione === "Postalizzata"
        ? "Postalizzate"
        : idIngiunzione.statoSanzione === "IngiunzioneChiusa"
        ? "Ingiunzione Chiusa"
        : idIngiunzione.statoSanzione === "Recupero Crediti"
        ? "Recupero Crediti"
        : idIngiunzione.statoSanzione === "IngiunzionePagata"
        ? "Ingiunzione Chiusa"
        : idIngiunzione.statoSanzione === "RicercaRapida"
        ? "Ricerca Rapida"
        : "Altro";

    this.state.pathPush =
      idIngiunzione.statoSanzione === "IngiunzioneAperta"
        ? "#/ingiunzioni?aperte"
        :idIngiunzione.statoSanzione === "Postalizzata"
        ? "#/ingiunzioni?postalizzate"
        : idIngiunzione.statoSanzione === "IngiunzioneChiusa"
        ? "#/ingiunzioni?chiuse"
        : idIngiunzione.statoSanzione === "Recupero Crediti"
        ? "#/RecuperoCrediti"
        : idIngiunzione.statoSanzione === "IngiunzionePagata"
        ? "#/ingiunzioni?pagate"
        : idIngiunzione.statoSanzione === "RicercaRapida"
        ? "#/RicercaRapida"
        : "Altro";

    this.detailIngiunzioneService.getDettaglioIngiunzione(
      idIngiunzione.id,
      // this.onSuccessGetDataUserControllore.bind(this)
      (result) => {
        this.setState({ sanzione: result });
        // this.detailIngiunzioneService.getStoricoPagamenti(result.idSanzione,
        //   (result)=>{
        //     if(result){
        //       this.setState({storicoPagamenti:[...result]})
        //     }
        //   },
        //   (error)=>{
        //     toast.error("Errore nel caricare lo storico pagamenti, Riprova")
        //     this.setState({storicoPagamenti:[]})
        //   })
        // this.state.paga.importoNetto = result.importoIngiunzione
        this.detailIngiunzioneService.getListStatiSanzione(
          result.idSanzione,
          (result) => {
            this.setState({ statiSanzione: result });
            // this.state.statiSanzione= result;
          }
        );

        this.detailIngiunzioneService.getDetailSanzione(
          result.idSanzione,
          (result) => {
            this.setState({
              dettaglioSanzione: result.sanzioni,
            });
            // this.state.dettaglioSanzione = result.sanzioni
            if (result.anagraficaTrasgressore.codiceFiscale) {
              this.detailIngiunzioneService.getRecidivo(
                result.anagraficaTrasgressore.codiceFiscale,
                (result) => {
                  // this.setState({ recidivo: result.data });
                  this.state.recidivo = result.data;

                  if (result.data.listaDiDettaglioSanzioni == null) {
                  } else {
                    result.data.map((val) => {
                      val.listaDiDettaglioSanzioni.map((val1) => {
                        this.state.recidivo.listaDiDettaglioSanzioni = [
                          ...this.state.recidivo.listaDiDettaglioSanzioni,
                          {
                            numSanzione: val1.numSanzione,
                            dataEmissione: val1.dataEmissione,
                            statoSanzione: val1.statoSanzione,
                            idSanzione: val1.idSanzione,
                          },
                        ];
                      });
                    });
                  }
                  // if(parseInt( ) < 1){

                  //   this.setState({ buttonRecidivi:true})
                  // }else{
                  //   this.setState({ buttonRecidivi:false})

                  // }
                  // console.log(this.state.recidivo);
                  this.state.recidivo.map((val) => {
                    // console.log(val.nSanz);
                    // this.state.valoreProv = parseInt(val.nSanz)
                    this.setState({ valoreProv: parseInt(val.nSanz) });
                  });
                }
              );
            }
          }
        );
      }
    );
  }

  onSuccessGetDataUserControllore(result) {
    // console.log(result);
    this.detailIngiunzioneService.getListStatiSanzione(
      result.idSanzione,
      (result) => {
        this.setState({ statiSanzione: result });
      }
    );

    this.detailIngiunzioneService.getDetailSanzione(
      result.idSanzione,
      (result) => {
        if (result.anagraficaTrasgressore.codiceFiscale) {
          this.detailIngiunzioneService.getRecidivo(
            result.anagraficaTrasgressore.codiceFiscale,
            (result) => {
              this.setState({ recidivo: result.data });
              //  console.log(i);
              // console.debug(result.data.nSanz.toString());
              // this.state.recidivo = {
              //   nome: result.data.nome,
              //   cognome: result.data.cognome,
              //   cf: result.data.cf,
              //   nSanz: result.data.nSanz,
              // };
              if (result.data.listaDiDettaglioSanzioni == null) {
              } else {
                result.data.map((val) => {
                  val.listaDiDettaglioSanzioni.map((val1) => {
                    this.state.recidivo.listaDiDettaglioSanzioni = [
                      ...this.state.recidivo.listaDiDettaglioSanzioni,
                      {
                        numSanzione: val1.numSanzione,
                        dataEmissione: val1.dataEmissione,
                        statoSanzione: val1.statoSanzione,
                        idSanzione: val1.idSanzione,
                      },
                    ];
                  });
                });
              }
              // if(parseInt( ) < 1){

              //   this.setState({ buttonRecidivi:true})
              // }else{
              //   this.setState({ buttonRecidivi:false})

              // }
              // console.log(this.state.recidivo);
              this.state.recidivo.map((val) => {
                // console.log(val.nSanz);
                // this.state.valoreProv = parseInt(val.nSanz)
                this.setState({ valoreProv: parseInt(val.nSanz) });
              });
            }
          );
        }
        this.setState({
          dettaglioSanzione: result.sanzioni,
        });
      }
    );
    this.setState({ sanzione: result });
  }

  renderPartStoricoStatiSanzione() {
    // console.log(this.state.dettaglioSanzione);
    if (this.state.statiSanzione && this.state.statiSanzione.length > 0) {
      return this.state.statiSanzione.map((stati, index) => {
        // console.log(stati);
        if (index < 3) {
          const {
            operazione,
            motivazioneOperazione,
            dataOperazione,
            matricola,
          } = stati;

          this.minuti =
            new Date(dataOperazione).getMinutes() < 10
              ? "0" + new Date(dataOperazione).getMinutes()
              : new Date(dataOperazione).getMinutes();
          // console.log(this.minuti);

          // console.log(dataOperazione);

          this.giornoCorretto =
            new Date(dataOperazione).getDate() < 9
              ? "0" + new Date(dataOperazione).getDate()
              : new Date(dataOperazione).getDate();
          this.meseCorretto =
            new Date(dataOperazione).getMonth() + 1 < 9
              ? "0" + (new Date(dataOperazione).getMonth() + 1)
              : new Date(dataOperazione).getMonth() + 1;

          this.dataStato =
            this.giornoCorretto +
            "/" +
            this.meseCorretto +
            "/" +
            new Date(dataOperazione).getFullYear();
          this.oraCambioStato =
            new Date(dataOperazione).getHours() + ":" + this.minuti;
          return (
            <>
              <li className="w-auto p-3 text-center">
                {" "}
                <time datetime={this.dataStato}>
                  {this.dataStato}
                  <br />
                  {this.oraCambioStato} <br /> <strong>{matricola}</strong>
                </time>{" "}
                <span className="text-center">
                  <br></br>
                  <strong>{operazione}</strong> {motivazioneOperazione}
                  {/* <p>{ this.oraCambioStato}</p> */}
                </span>
              </li>
            </>
          );
        }
      });
    } else {
      return <tr> Dati sugli stati della sanzione non disponibili.</tr>;
    }
  }

  estendiStoricoSanzione() {
    this.setState({ showModalStoricoSanzione: true });
  }
  chiudiStoricoSanzione() {
    this.setState({ showModalStoricoSanzione: false });
  }
  mapAllStoricoStatiSanzione() {
    return this.state.statiSanzione.map((stato, index) => {
      const { operazione, motivazioneOperazione, dataOperazione, matricola } = stato;

      let minutiStorico =
        new Date(dataOperazione).getMinutes() < 10
          ? "0" + new Date(dataOperazione).getMinutes()
          : new Date(dataOperazione).getMinutes();

      let giornoCorretto =
        new Date(dataOperazione).getDate() < 9
          ? "0" + new Date(dataOperazione).getDate()
          : new Date(dataOperazione).getDate();
      let meseCorretto =
        new Date(dataOperazione).getMonth() + 1 < 9
          ? "0" + (new Date(dataOperazione).getMonth() + 1)
          : new Date(dataOperazione).getMonth() + 1;

      let dataStato =
        giornoCorretto +
        "/" +
        meseCorretto +
        "/" +
        new Date(dataOperazione).getFullYear();

      let oraCambioStato =
        new Date(dataOperazione).getHours() + ":" + minutiStorico;

      return (
        {
          dataStato: dataStato,
          oraCambioStato: oraCambioStato,
          matricola: matricola,
          operazione: operazione,
          motivazioneOperazione: motivazioneOperazione
        }
      );
    });
  }
  getModalStoricoStatiSanzione() {
    let storicoStati = this.mapAllStoricoStatiSanzione();
    return (
      <Modal size="lg"  show={this.state.showModalStoricoSanzione}>
        <Modal.Header>
          <Modal.Title>Storico Sanzione / Ingiunzione</Modal.Title>
          <button
            type="button"
            class="btn btn-warning"
            onClick={() => this.printStatiSanzioneToPdf(this.state.sanzione.numeroSanzione, storicoStati)}
          >
            <i className="fas fa-file text-white"></i> Scarica PDF
          </button>
        </Modal.Header>
        <Modal.Body
          style={{ maxHeight: "calc(100vh - 210px)", overflowY: "auto"}}
        >
            <ul className="events w-auto p-3">
              {this.renderAllStoricoStatiSanzione(storicoStati)}
            </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={this.chiudiStoricoSanzione.bind(this)}
          >
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
  renderAllStoricoStatiSanzione(storicoStati) {
    if (storicoStati && storicoStati.length > 0) {
      return storicoStati.map((stato, index) => {
        return (
          <li className="w-auto p-3 text-center">
            {" "}
            <time datetime={stato.dataStato}>
              {stato.dataStato} <br />
              {stato.oraCambioStato}
              <br /> <strong>{stato.matricola}</strong>
            </time>{" "}
            <span>
              <br></br>
              <strong>{stato.operazione}</strong>{stato.motivazioneOperazione}{" "}
            </span>
          </li>
        );
      });
    } else {
      return <tr> Dati sugli stati della sanzione non disponibili.</tr>;
    }
  }

  chiudiScheda() {
    sessionStorage.removeItem("ListaSaznioniRecidivo");
    this.setState({ showModalSanzioniRecidivo: false });
  }

  tabbellaSanzioniRecidivo() {
    var moment = require("moment");
    this.state.recidivo.map((val) => {
      // console.log(val.nSanz);
      this.state.valoreProv = parseInt(val.nSanz);
    });
    return (
      <>
        <Modal size="lg" show={this.state.showModalSanzioniRecidivo}>
          <Modal.Header>
            <Modal.Title>Scheda Sanzioni Recidivo </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.recidivo.map((val, index) => {
              return (
                <>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">Numero Sanzione</th>
                        <th scope="col">Data Emissione</th>
                        <th scope="col">stato</th>
                      </tr>
                    </thead>
                    <tbody>
                      {val.listaDiDettaglioSanzioni.map((val1) => {
                        return (
                          <>
                            <>
                              <tr
                                onClick={() => {
                                  var idIngiunzione = JSON.parse(
                                    sessionStorage.getItem("rowIngiunzione")
                                  );
                                  const valoriSaznionePush = {
                                    id: val1.idSanzione,
                                    statoSanzione: "Recidivo",
                                    idSaznioneProvenienza:
                                      this.state.sanzione.idSanzione,
                                    numeroIngiunzioneProvenientza:
                                      idIngiunzione.id,
                                  };

                                  this.detailSanzioneService.getDetailSanzione(
                                    val1.idSanzione,
                                    this.onSuccessGetDetailSanzione.bind(this)
                                  );

                                  sessionStorage.removeItem("rowSanzione");
                                  sessionStorage.setItem(
                                    "rowSanzione",
                                    JSON.stringify(valoriSaznionePush)
                                  );
                                  this.props.history.push("/detailSanzione");
                                  this.setState({
                                    showModalSanzioniRecidivo: false,
                                  });
                                }}
                              >
                                <td>{val1.numSanzione}</td>
                                <td>{geDataFormat(val1.dataEmissione)}</td>
                                <td>{val1.statoSanzione}</td>
                              </tr>
                            </>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </>
              );
            })}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.chiudiScheda.bind(this)}>
              Chiudi scheda Sanzioni
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  annullaInviaMail() {
    this.setState({ showModalInvioMail: false });
  }
  confermaInviaMail() {
    this.setState({ showModalInvioMail: false });
  }
  changeTextIndirizzoInvioMail(event) {
    //ESIMg
    this.state.fieldIndirizzoMail = event.target.value;
    this.setState({ fieldIndirizzoMail: this.state.fieldIndirizzoMail });
    if (!validEmail.test(this.state.fieldIndirizzoMail)) {
      this.setState({ isErrorEmail: true });
    } else {
      this.setState({ isErrorEmail: false });
    }
  }

  modalInvioEmail() {
    return (
      <Modal show={this.state.showModalInvioMail}>
        <Modal.Header>
          <Modal.Title>Invio Mail Sanzione</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          inserisci la mail del destinatario
          <input
            className="form-control"
            type="text"
            value={this.state.fieldIndirizzoMail}
            onChange={this.changeTextIndirizzoInvioMail.bind(this)}
          ></input>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={this.annullaInviaMail.bind(this)}
          >
            Annulla
          </Button>
          <Button
            variant="primary"
            disabled={this.state.isErrorEmail}
            onClick={this.confermaInviaMail.bind(this)}
          >
            Invia Mail
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  modalStoricoPagamentiHandler(){
    this.setState((prevState)=>({showModalStoricoPagamenti:!prevState.showModalStoricoPagamenti}));
  }

  downloadRicevuta(id,numeroRata){
    let numeroSanzione = this.state.sanzione.numeroSanzione;

    this.detailIngiunzioneService.getRicevutaPagamento(id,numeroRata,(result)=>{
      const element = document.createElement('a')
      element.href = `data:application/pdf;base64,${result}`
      element.download = `attestato_pagamento_${numeroSanzione}_${numeroRata}.pdf`
      document.body.appendChild(element)
      element.click()
    },
    (error)=>{
      toast.error("Errore Download, Riprova piu tardi")
    })

  }


  modalStoricoPagamenti(){
    return (
      <>
        <Modal size="xl" show={this.state.showModalStoricoPagamenti}>
          <Modal.Header>
            <Modal.Title>Storico Pagamenti</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
            {this.state.storicoPagamenti.length > 0 
            ? (<Table size="sm" responsive>
              <thead className="text-center">
                <tr>
                  <th>Data Contabile</th>
                  <th>Tipo Pagamento</th>
                  <th>Importo Netto</th>
                  <th>Codice Transazione</th>
                  <th>Note</th>
                  <th>Download</th>
                </tr>

              </thead>
              <tbody>
              {this.state.storicoPagamenti.map((pagamento)=>{
              return <tr className="text-center">
                <td>{geDataFormat(pagamento.dataContabile)}</td>
                <td>{pagamento.tipoPagamento}</td>
                <td>{(pagamento.importoNetto / 100).toLocaleString('it-IT',{minimumFractionDigits:2})}</td>
                <td>{pagamento.codiceTx}</td>
                <td>{pagamento.note}</td>
                <td>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16"  onClick={()=>this.downloadRicevuta(this.state.sanzione.idSanzione,pagamento.numeroRata)}>
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                  </svg>
                </td>
              </tr>
            })}
              </tbody>
            </Table>)
            : <p>Non ci sono Pagamenti</p>}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.modalStoricoPagamentiHandler.bind(this)}
            >
              Annulla
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  dettaglioIngiunzione() {
    var idIngiunzione = JSON.parse(sessionStorage.getItem("rowIngiunzione"));
    return (
      <>
        <div className="container-fluid">
          <div className="justify-content-between">
            <div className="d-flex justify-content-between">
            <h1 className="d-sm-flex align-items-center justify-content-between">
              Ingiunzione<br></br>
              {/* <button type="button" className="btn btn-warning" onClick={()=>{
                this.setState({showModalInvioMail:true})
              }}>
                <i className="fas  fa-mail-bulk text-white"></i> Invio Mail
              </button> */}
              &nbsp;
            </h1>
            <div className="d-flex gap-2 justify-content-center align-items-center mr-3">
              <div className="d-flex flex-column flex-lg-row gap-lg-2 gap-1">
                <Button
                size="sm"
                variant="warning"
                onClick={()=>{
                    this.detailIngiunzioneService.getStoricoPagamenti(this.state.sanzione.idSanzione,
                      (result)=>{
                        if(result){
                          this.setState({storicoPagamenti:[...result]})
                          this.modalStoricoPagamentiHandler()
                        }
                      },
                      (error)=>{
                        toast.error("Errore nel caricare lo storico pagamenti, Riprova")
                        this.setState({storicoPagamenti:[]})
                      })
                }}>
                  <i className="fas  fa-history text-white"></i> Storico Pagamenti
                </Button>

              </div>

            </div>
            </div>
            
            {/* onClick = {this.inviaMail.bind(this)} */}
            <small style={{ fontSize: "14px" }} className="mb-2 text-gray-800">
              Ingiunzioni &#8594;{" "}
              {this.state.path !== "Altro" ?<a
                onClick={() => {
                  window.location.href = this.state.pathPush;
                }}
              >
                <u>{this.state.path}</u>
                </a>
              :<span>{this.state.path}</span>}
              &#8594; Dettaglio Ingiunzione
            </small>
          </div>

          <br></br>
          <div className="col">
            <div className="row">
              <div className="col">
                <div className="row">
                  <div className="col-sm-12">
                    <b> Numero Ingiunzione:</b> {idIngiunzione.id}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Numero Sanzione:</b>{" "}
                    {this.state.sanzione.numeroSanzione}
                  </div>
                </div>
                {/* <br></br> */}
                {/* <div className="row">
                  <div className="col-sm-12">
                    <b> Importo Sanzione: </b>
                    <NumberFormat
                      thousandsGroupStyle="thousand"
                      value={this.state.sanzione.importo / 100}
                      prefix="€"
                      decimalSeparator="."
                      displayType="text"
                      type="text"
                      thousandSeparator={true}
                      allowNegative={true}
                    />
                    <br></br>
                    <ul>
                      <li>simone</li>
                    </ul>
                  </div>
                </div> */}
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Matricola Controllore:</b>{" "}
                    {this.state.sanzione.matricolaControllore}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Stato Ingiunzione:</b> {this.state.sanzione.statoIng}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Data Creazione Ingiunzione:</b>{" "}
                    {geDataFormat(this.state.sanzione.dataCreazioneIngiunzione)}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Data Emissione Sanzione:</b>{" "}
                    {geDataFormat(this.state.sanzione.dataDiEmissioneSanzione)}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Annotazione Controllore:</b>{" "}
                    {this.state.sanzione.annotazioneControllore}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b>Verbale Fatto a bordo:</b>{" "}
                    {this.state.sanzione.isverbaleFattoABordo === 0
                      ? "NO"
                      : "SI"}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Località:</b>{" "}
                    {this.state.dettaglioSanzione.localita.nomeLocalita}
                  </div>
                </div>
                {/* {this.gestioneAllegatiModal()} */}
                <br></br>

                {/* {this.state.valoreProv <= 1  ? (
                    ""
                  ) : (
                    <> */}
                {/* {this.state.rowSanzionePrev.idSaznioneProvenienza === 0 &&
                      this.state.rowSanzionePrev.numeroSanzioneProvenienza ===
                        "" ? ( */}
                {this.state.valoreProv <= 1 ? (
                  ""
                ) : (
                  <>
                    {/* {this.state.rowSanzionePrev.idSaznioneProvenienza === 0 &&
                      this.state.rowSanzionePrev.numeroSanzioneProvenienza ===
                        "" ? ( */}
                    <div className="col">
                      <i
                        onClick={() => {
                          if (
                            this.state.rowSanzionePrev.idSaznioneProvenienza ===
                            0
                          ) {
                            this.setState({
                              showModalSanzioniRecidivo: true,
                            });
                          } else {
                          }
                        }}
                      >
                        <img
                          src={R}
                          width={"25px"}
                          height={"25px"}
                          alt="Recidivi"
                        />
                      </i>
                    </div>
                    {/* ) : (<>
                        {
                        </>)} */}
                  </>
                )}
                {/* ) : (<>
                        {}
                        </>)} */}
                {/* </>
                  )} */}
              </div>
              <div className="col">
                <div className="col">
                  <fieldset className="border p-2">
                    <b>Composizione Importo Ingiunzione </b>
                    <br></br>
                    <br></br>
                    <ul>
                    {this.state.dettaglioSanzione
                          .anagraficaTipologiaSanzione.aggiungiPrezzoTratta ? <>
                           <li>
                        {/* <small className="text-danger">*</small> */}
                        {/* {this.state.dettaglioSanzione.anagraficaStati.nomeStato === "Agli Atti"} */}
                        Importo Titolo:{" "}
                        {/* <NumberFormat
                          thousandsGroupStyle="thousand"
                          value={0}
                          prefix="€"
                          decimalSeparator="."
                          displayType="text"
                          type="text"
                          thousandSeparator={true}
                          allowNegative={true}
                        /> */}
                        {this.state.dettaglioSanzione
                          .anagraficaTipologiaSanzione.aggiungiPrezzoTratta ? (
                          <b>
                            {(
                              this.state.dettaglioSanzione.localita.importo /
                              100
                            ).toFixed(2)
                              .toString()
                              .replace(".", ",")}
                            €
                          </b>
                        ) : (
                          <b>0€</b>
                        )}
                        <br></br>
                        <br></br>
                      </li>
                          </>:""}
                      {this.state.sanzione.spacchettatoDTO.listaSpacchettatiIntero!==[]
                      ? this.state.sanzione.spacchettatoDTO.listaSpacchettatiIntero.map((spacchettato)=>{
                        return (
                          <li>{spacchettato.descrizione}: <b>{(spacchettato.valore / 100).toFixed(2).toString().replace(".", ",")} €</b></li>
                        )
                      })
                    :<></>}
                    </ul>
                    <hr></hr>
                    <div className="text-center">
                      {/* {giorniAllaScadenza < 5 ? ( */}

                      <>
                        <b>Importo Totale Ingiunzione: </b>
                        {/* <NumberFormat
                            thousandsGroupStyle="thousand"
                            value={this.state.sanzione.importo / 100}
                            prefix="€"
                            decimalSeparator="."
                            displayType="text"
                            type="text"
                            thousandSeparator={true}
                            allowNegative={true}
                          /> */}
                        <b>
                          {/* {(this.state.sanzione.importoIngiunzione / 100)
                            .toString()
                            .replace(".", ",")}
                          € */}
                          {/* {this.state.impostazioniSpese.map((val) => {
                            if (val.key === "spesa_notifica_ing") {
                              return (val.value / 100)
                                .toString()
                                .replace(".", ",");
                            }
                          })}
                          € */}
                          {this.state.dettaglioSanzione
                            .anagraficaTipologiaSanzione
                            .aggiungiPrezzoTratta ? (
                            <>
                            {(this.state.sanzione.importoIngiunzione / 100).toFixed(2)
                            .toString()
                            .replace(".", ",")} €
                            </>
                          ) : (
                            <>
                              {/* {this.state.impostazioniSpese.map((val, index) => {
                                
                                if (val.key === "spesa_notifica_ing") {
                                 this.state.valoretotaleImpostazioniIngiunzione = this.state.valoretotaleImpostazioniIngiunzione+ parseInt(val.value)
                                }
                                if (val.key === "spesa_istruttoria") {
                                  this.state.valoretotaleImpostazioniIngiunzione  = this.state.valoretotaleImpostazioniIngiunzione+ parseInt(val.value)
                                }
                                if (val.key === "spesa_penale") {
                                  this.state.valoretotaleImpostazioniIngiunzione  = this.state.valoretotaleImpostazioniIngiunzione+ parseInt(val.value)
                                }
                                if (val.key === "spesa_procedura") {
                                  this.state.valoretotaleImpostazioniIngiunzione  = this.state.valoretotaleImpostazioniIngiunzione+ parseInt(val.value)
                                }
                                if(index + 1=== this.state.impostazioniSpese.length )
                                return ((this.state.dettaglioSanzione.importo + this.state.valoretotaleImpostazioniIngiunzione  )/100)
                                .toString()
                                .replace(".", ",")
                              })} */}
                              {(this.state.sanzione.importoIngiunzione / 100).toFixed(2)
                            .toString()
                            .replace(".", ",")} €
                            </>
                          )}
                        </b>
                      </>

                      <br></br>
                    </div>
                  </fieldset>
                </div>
              </div>
              <br></br>
              <div className="col-sm-6">
                <fieldset className="border p-2">
                  <legend className="w-auto" style={{ color: "#4e73df" }}>
                    &nbsp;&nbsp;Storico Stati Sanzione / Ingiunzione
                  </legend>
                  <br></br>
                  <ul className="events w-auto p-3">
                    {this.renderPartStoricoStatiSanzione()}
                  </ul>
                  <br></br>
                  <div className="d-sm-flex  justify-content-between mb-6">
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={this.estendiStoricoSanzione.bind(this)}
                    >
                      <i className="fas  fa-history text-white"></i> Estendi
                      Storico
                    </button>
                  </div>
                </fieldset>
                <br></br>
              </div>
              <br></br>
            </div>
            {(this.state.path === "Ingiunzione Aperta" || this.state.path === "Ricerca Rapida") && (this.state.sanzione.statoIng === "Ingiunzione")
              ? this.showBottonScrittoDifensivo()
              : ""}
            {/* {this.showBottonScrittoDifensivo()} */}
            <br></br>
          </div>
        </div>
        <br></br>
        {/* {this.showBottonScrittoDifensivo()} */}
      </>
    );
  }

  showBottonScrittoDifensivo() {
    return (
      <>
        <br></br>
        <div className="row">
          {/* <div className="col d-flex justify-content-center">
            <button
              type="button"
              // disabled={this.state.disableInput}
              onClick={this.showModalSbloccaSanzione.bind(this)}
              className="btn btn-primary"
            >
              Sblocca Sanzione
            </button>
          </div> */}
          <div className="col d-flex justify-content-center">
            {/* {this.state.listaStatiTo.map((valori) => {
              if (valori.nomeStato === "Agli Atti") { */}
            <button
              type="button"
              // disabled={this.state.disableInput}
              // id={valori.idStato}
              // onClick={this.showModalAgliAttiScrittoDifensivo.bind(this)}
              className="btn btn-primary"
              onClick={() => {
                // alert("Funzionalita in sviluppo . . .");
                this.setState({ showModalAgliAttiScrittoDifensivo: true });
              }}
            >
              Agli Atti
            </button>
            {/* }
            })} */}
          </div>
          <div className="col d-flex justify-content-center">
            <button
              type="button"
              // disabled={this.state.disableInput}
              className="btn btn-primary"
              // onClick={this.showModalGestioneAllegatiAggiungiScritto.bind(this)}
              onClick={
                this.paga.bind(this)
                // () => {
                // alert("Funzionalita in sviluppo . . .");
              }
            >
              Paga
            </button>
          </div>
          {/* {this.state.sanzione.statoIng === "Rateizzato" ? (
            ""
          ) : this.state.dettaglioSanzione.anagraficaStati.nomeStato ===
            "Rateizzato" ? (
            ""
          ) : (
            <div className="col d-flex justify-content-center">
              <button
                type="button"
                // disabled={this.state.disableInput}
                className="btn btn-primary"
                // onClick={this.showModalGestioneAllegatiAggiungiScritto.bind(this)}
                onClick={() => {
                  this.setState({ showModalRateizzaSanzione: true });
                }}
              >
                Rateizza
              </button>
            </div>
          )} */}

          {/* <div className="col d-flex justify-content-center">
            <button
              type="button"
              // disabled={this.state.disableInput}
              onClick={() => alert("Funzionalita in sviluppo")}
              className="btn btn-primary"
            >
              Scarica Allegati
            </button>
          </div> */}
        </div>
      </>
    );
  }
  onChangeAgliAttiScrittoDifensivo(event) {
    this.state.agliAttiNota = event.target.value;
    this.setState({ state: this.state.agliAttiNota });
    if (this.state.agliAttiNota.length < 5) {
      this.setState({ agliAttiScrittoDifensivo: true });
    } else {
      this.setState({ agliAttiScrittoDifensivo: false });
    }
  }

  modalAgliAttiScrittoDifensivo() {
    return (
      <>
        <Modal size="lg" show={this.state.showModalAgliAttiScrittoDifensivo}>
          <Modal.Header>
            <Modal.Title>Conferma Agli Atti</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col">
              <label>Note</label>
              <textarea
                className="form-control"
                type="area"
                placeholder="Agli atti (minimo 5 caratteri)"
                value={this.state.agliAttiNota}
                onChange={this.onChangeAgliAttiScrittoDifensivo.bind(this)}
              ></textarea>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <>
              <Button
                variant="primary"
                // disabled={this.state.fileSizeError}
                onClick={this.confermaAgliAttiScrittoDifensivo.bind(this)}
                disabled={this.state.agliAttiScrittoDifensivo}
              >
                Conferma
              </Button>
              <Button
                variant="secondary"
                onClick={this.showModalAgliAttiScrittoDifensivoAnnulla.bind(
                  this
                )}
              >
                Annulla
              </Button>
            </>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  confermaAgliAttiScrittoDifensivo() {
    this.setState({loading:true})
    // console.log(this.state.noteAgliAtti);

    this.detailIngiunzioneService.AgliAttiPerLoscrittoDifensivo(
      this.state.sanzione,
      this.state.agliAttiNota,
      this.state.sanzione.idSanzione,
      20,
      (result) => {
        if (
          result ===
          "Passaggio di stato, per ingiunzione, avvenuto correttamente"
        ) {
          toast.success(
            "Passaggio di stato, per ingiunzione, avvenuto correttamente"
          );
          this.props.history.push("/ingiunzioni");
        } else {
          toast.error(
            "Passaggio di stato, per ingiunzione, non avvenuto correttamente"
          );
          this.props.history.push("/ingiunzioni");
        }
      }
    );

    this.setState({ showModalAgliAttiScrittoDifensivo: false });
  }

  showModalAgliAttiScrittoDifensivo(event) {
    this.state.idStatoPassagio = parseInt(event.target.id);
    this.setState({ showModalAgliAttiScrittoDifensivo: true });
  }
  showModalAgliAttiScrittoDifensivoAnnulla() {
    this.state.noteAgliAtti = "";
    this.setState({
      showModalAgliAttiScrittoDifensivo: false,
      agliAttiScrittoDifensivo: true,
    });
  }

  /*modalStorico() {
    return (
      <>
        <Modal size="lg" show={this.state.showModalStoricoSanzione}>
          <Modal.Header>
            <Modal.Title>Storico Sanzione / Ingiunzione</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{ maxHeight: "calc(100vh - 210px)", overflowY: "auto" }}
          >
              <ul className="events w-auto p-3">
                {this.renderAllStoricoStatiSanzione()}
              </ul>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.chiudiStoricoSanzione.bind(this)}
            >
              Chiudi
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }*/

  changeTextImportoNetto(event) {
    this.state.paga.importoNetto = event.target.value
      .toString()
      .replace(".", ",");
    this.setState({ paga: this.state.paga });

    var diff = calculateTimeDifferenceTwoDates(
      new Date(),
      moment(this.state.sanzione.dataDiEmissione, "DD/MM/YYYY").toDate()
    );
    var giorniAllaScadenza = parseInt(diff);
    this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });

    giorniAllaScadenza <= 5
      ? (this.importoUguale = this.state.sanzione.importoRidotto)
      : (this.importoUguale = this.state.sanzione.importo);

    // console.log(parseFloat(this.state.paga.importoNetto * 100));
    // console.log(parseFloat(this.importoUguale * 100));

    //

    if (this.state.seIlPagamentoDerivaDaUnaRata === true) {
      if (
        parseFloat(this.state.paga.importoNetto * 100) <
        parseFloat(this.importoUguale)
      ) {
        this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
      } else {
        if (
          this.state.paga.codiceTx &&
          this.state.paga.dataContabile &&
          this.state.paga.note &&
          this.state.paga.tipoPagamento
        ) {
          this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
        }
      }
    } else {
      this.state.importoRataInferioreAImportoRata =
        this.state.importoRataInferioreAImportoRata.toString().replace(",", "");
      // this.state.paga.importoNetto  =
      // this.state.paga.importoNetto.toString().replace(".", "");
      if (
        parseFloat(this.state.paga.importoNetto * 100) <
        parseFloat(this.state.importoRataInferioreAImportoRata)
      ) {
        this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
      } else {
        if (
          this.state.paga.codiceTx &&
          this.state.paga.dataContabile &&
          this.state.paga.note &&
          this.state.paga.tipoPagamento
        ) {
          this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
        }
      }
    }
  }
  changeTextCodiceTransazione(event) {
    this.state.paga.codiceTx = event.target.value.toString().toUpperCase();
    this.setState({ paga: this.state.paga });
    if (
      this.state.paga.codiceTx &&
      this.state.paga.dataContabile &&
      this.state.paga.note &&
      this.state.paga.tipoPagamento &&
      this.state.paga.importoNetto
    ) {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
    } else {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
    }
  }
  changeTextNotaPagaSanzione(event) {
    this.state.paga.note = capitalizeFirstLetter(event.target.value);
    this.setState({ paga: this.state.paga });
    if (
      this.state.paga.codiceTx &&
      this.state.paga.dataContabile &&
      this.state.paga.note &&
      this.state.paga.tipoPagamento &&
      this.state.paga.importoNetto
    ) {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
    } else {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
    }
  }
  changeTextTipoPagamento(event) {
    this.state.paga.tipoPagamento = event.target.value;
    this.setState({ paga: this.state.paga });
    // console.log(this.state.paga.tipoPagamento);
    if (
      this.state.paga.codiceTx &&
      this.state.paga.dataContabile &&
      this.state.paga.note &&
      this.state.paga.tipoPagamento &&
      this.state.paga.importoNetto
    ) {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
    } else {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
    }
  }

  inputImportoRata(event) {
    // console.log(event.target);
    // this.importo = this.state.giorniAllaScadenza < 5
    // ? this.state.sanzione.anagraficaTipologiaSanzione.importoRidotto
    //     .toString()
    //     .substring(
    //       0,
    //       this.state.sanzione.anagraficaTipologiaSanzione.importoRidotto.toString()
    //         .length - 1
    //     )
    // : this.state.sanzione.importo / 100;
    this.importo = this.state.sanzione.importoIngiunzione / 100;
    var indiceArrray = parseInt(event.target.id);
    // console.log(this.state.tableRata);
    this.state.tableRata[indiceArrray - 1].importo = event.target.value;
    this.setState({ tableRata: this.state.tableRata });
    this.state.sommaDiTuttiGliImportiRata = 0;
    this.state.tableRata.map((rata, index) => {
      this.state.sommaDiTuttiGliImportiRata =
        parseFloat(rata.importo) + this.state.sommaDiTuttiGliImportiRata;
    });
    this.state.statosingoloImporto.map((val) => {
      if (val.state === true) {
        this.setState({ rateizzaButton: true });
      } else {
        if (this.state.sommaDiTuttiGliImportiRata >= this.importo) {
          this.setState({ rateizzaButton: false });
        }
      }
    });

    if (this.state.tableRata[indiceArrray - 1].importo < 20.0) {
      this.state.statosingoloImporto[indiceArrray - 1].stato = true;
      this.setState({ rateizzaButton: true });
    } else {
      this.state.statosingoloImporto[indiceArrray - 1].stato = false;
    }
    // console.log(this.state.statosingoloImporto);

    this.importo = parseFloat(this.state.sanzione.importo) / 100;

    this.state.tableRata.map((rata, index) => {
      if (index === 0) {
        this.count = 0;
      }
      if (this.count === 0) {
        if (rata.importo < 20.0) {
          this.count = 1;
          this.setState({ rateizzaButton: true });
        }
      }
    });

    // const valore = this.state.statosingoloImporto.map((val) => val.stato).indexOf(true);

    // console.log(valore);

    // if (this.state.sommaDiTuttiGliImportiRata >= this.importo) {
    //   this.setState({ rateizzaButton: false });
    // } else {
    //   this.setState({ rateizzaButton: true });
    // }

    // this.state.tableRata.map((importo) => {
    //   if(importo.importo < 20.0){
    //     this.setState({ rateizzaButton: true });
    //   }else {
    //     this.setState({ rateizzaButton: false });
    //   }
    // })
  }

  ConfermaRateizzaSanzione() {
    // console.log(this.creaRateizza)
    this.state.tableRata.map((rata) => {
      rata.spesaIncassoRata = parseFloat(this.state.creaRata.SpeseIncassoRata);

      var importointero = rata.importo.toString().replace(".", "");

      if (
        rata.importo.toString().includes(".") ||
        rata.importo.toString().includes(",")
      ) {
        rata.importo = parseFloat(importointero);
      } else {
        rata.importo = parseFloat(importointero * 100);
      }

      // console.log(rata.importo);
      // if (importointero.toString().length === 2) {
      //   rata.importo = parseInt(importointero + "00");
      // } else {
      //   rata.importo = parseInt(importointero);
      // }
    });
    // console.log(this.state.tableRata);
    this.creaRateizza = {
      numeroSanzione: this.state.sanzione.numeroSanzione,
      rate: this.state.tableRata,
    };
    // console.log(this.creaRateizza);
    this.setState({ loading: true });
    this.detailIngiunzioneService.creaRateizza(
      this.creaRateizza,
      this.state.sanzione.idSanzione,
      14,
      (result) => {
        if (result) {
          toast.success(result, {
            position: toast.POSITION.TOP_RIGHT,
          });
          this.setState({ loading: false });

          window.location.reload();
        } else {
          toast.error(result, {
            position: toast.POSITION.TOP_RIGHT,
          });
          this.setState({ loading: false });
        }
      }
    );
    // this.state.sommaDiTuttiGliImportiRata = 0;
    // let sommaRateSenzaSpese = 0;
    // let importo =  parseFloat(this.state.sanzione.importo) / 100;
    // this.state.tableRata.map((rata, index) => {
    //   this.importo = parseFloat(rata.importo) + this.state.sommaDiTuttiGliImportiRata;
    //   this.state.sommaDiTuttiGliImportiRata =
    //     parseFloat(rata.importo) + this.state.sommaDiTuttiGliImportiRata;
    //   sommaRateSenzaSpese = sommaRateSenzaSpese + (parseFloat(rata.importo) - parseFloat(this.state.creaRata.SpeseIncassoRata ))
    // });
    // if(sommaRateSenzaSpese === importo){
    //   this.setState({rateizzaButton:false})
    // }else{
    //   this.setState({rateizzaButton:true})
    // }
    this.state.tableRata = [];
    this.state.creaRata.SpeseIncassoRata = "";
    this.setState({
      showModalRateizzaSanzione: false,
      creaRata: this.state.creaRata,
      rateizzaButton: false,
      errorNumeroRata: false,
      calcolaRata: true,
      resetRateizzaButton: true,
    });
  }
  showModalRateizzaSanzione(event) {
    this.state.idStatoPassagio = parseInt(event.target.id);
    this.setState({ showModalRateizzaSanzione: true });
  }

  optionNumeroRate() {
    const nuemroRate = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

    return (
      <>
        {nuemroRate.map((numero) => {
          return <option value={numero}>{numero}</option>;
        })}
      </>
    );
  }

  selectNumeroRate(event) {
    this.state.creaRata.numeroDiRata = event.target.value;
    this.setState({
      creaRata: this.state.creaRata,
      rateizzaButton: false,
      errorNumeroRata: false,
    });
    //LAVORO
    this.state.statosingoloImporto = [];
    this.state.tableRata = [];
    this.state.importoDaSalvarestate = [];
    var diff = calculateTimeDifferenceTwoDates(
      new Date(),
      moment(this.state.sanzione.dataDiEmissione, "DD/MM/YYYY").toDate()
    );

    this.importo =
      this.state.giorniAllaScadenza <= 5
        ? this.state.sanzione.anagraficaTipologiaSanzione.importoRidotto / 100
        : this.state.sanzione.importo / 100;
    // console.log(this.importo / event.target.value > 20);
    if (this.importo / event.target.value < 20) {
      this.setState({
        errorNumeroRata: true,
        rateizzaButton: true,
        resetRateizzaButton: true,
      });
      this.state.resetRateizzaButton = true;
      this.state.rateizzaButton = true;
      this.state.calcolaRata = true;
    }
    const nuemroRate = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    let giornoRata = new Date();
    nuemroRate.slice(0, parseInt(event.target.value)).map((rata, index) => {
      // index === 0 ? giornoRata : giornoRata.setDate(giornoRata.getDate() + 30)
      if (index === 0) {
        this.scadenzaPagamento = giornoRata;
        giornoRata.setDate(giornoRata.getMonth() + 1);
      } else {
        this.scadenzaPagamento = giornoRata.setDate(giornoRata.getDate() + 30);
        this.scadenzaPagamento = giornoRata.setDate(giornoRata.getMonth() + 1);
      }
      this.state.tableRata = [
        ...this.state.tableRata,
        {
          numeroRata: `${index + 1}`,
          // importo: (this.importo / parseInt(event.target.value)).toFixed(2),
          importo: "",
          stato: "daPagare",
          dataScandenza: new Date(this.scadenzaPagamento).toJSON(),
          // new Date(this.scadenzaPagamento).getDate() +
          // "/" +
          // (new Date(this.scadenzaPagamento).getMonth() + 1) +
          // "/" +
          // new Date(this.scadenzaPagamento).getFullYear(),
        },
      ];
      // }
    });
    this.state.sommaDiTuttiGliImportiRata = 0;
    this.state.tableRata.map((rata, index) => {
      this.state.sommaDiTuttiGliImportiRata =
        parseFloat(rata.importo) + this.state.sommaDiTuttiGliImportiRata;
    });

    this.state.tableRata.map((numerorata, index) => {
      this.state.statosingoloImporto = [
        ...this.state.statosingoloImporto,
        {
          nueroRata: false,
        },
      ];
    });

    this.importo = parseFloat(this.state.sanzione.importo) / 100;
    if (this.state.sommaDiTuttiGliImportiRata === this.importo) {
      this.setState({ rateizzaButton: false });
    } else {
      this.setState({ rateizzaButton: true });
    }

    // console.log(this.state.tableRata);

    // console.log(event.target.value)
  }

  importoInCentesimiIncassoRata(event) {
    event.preventDefault();
    this.state.creaRata.SpeseIncassoRata = event.target.value;
    this.setState({ creaRata: this.state.creaRata }); //, rateizzaButton:true

    this.state.tableRata.map((importoDaSalvare) => {
      this.state.importoDaSalvarestate = [
        ...this.state.importoDaSalvarestate,
        {
          importoSalvato: importoDaSalvare.importo,
        },
      ];
    });
    // console.log(this.state.importoDaSalvarestate);
    // if (event.target.value === 0 || event.target.value === "") {
    //   this.state.creaRata.SpeseIncassoRata = 0;
    // }

    this.state.tableRata.map((rata, index) => {
      // console.log("siongola rata " + rata.importo);
      // console.log(this.state.importoDaSalvarestate);

      this.valore =
        // parseFloat(rata.importo) +
        parseFloat(this.state.importoDaSalvarestate[index].importoSalvato) +
        parseFloat(this.state.creaRata.SpeseIncassoRata);
      // console.log(
      //   parseFloat(
      //     rata.importo + this.state.creaRata.SpeseIncassoRata
      //   )
      // );

      this.setState({
        sommaDiTuttiGliImportiRata: this.state.sommaDiTuttiGliImportiRata,
      });
      return (
        <>
          {event.target.value === ""
            ? (rata.importo =
                this.state.importoDaSalvarestate[index].importoSalvato)
            : (rata.importo = this.valore.toFixed(2))}
          {/* {rata.importo = this.valore.toFixed(2)} */}
        </>
      );
      // }
    });

    // if (this.importo + ) {
    //   this.setState({ rateizzaButton: false });
    // } else {
    //   this.setState({ rateizzaButton: true });
    // }
  }

  AnnullaRateizzaSanzione() {
    this.state.sommaDiTuttiGliImportiRata = 0;
    this.state.statosingoloImporto = [];
    this.state.creaRata.SpeseIncassoRata = "";
    this.state.creaRata.numeroDiRata = 0;
    this.setState({
      showModalRateizzaSanzione: false,
      creaRata: this.state.creaRata,
      rateizzaButton: true,
      errorNumeroRata: false,
      tableRata: [],
      SpeseIncassoRata: "",
      calcolaRata: true,
      resetRateizzaButton: true,
    });
  }

  modalRateizzaSanzione() {
    return (
      <>
        <>
          <Modal size="lg" show={this.state.showModalRateizzaSanzione}>
            <Modal.Header>
              <h4>Rateizza Sanzione </h4>
              <Modal.Title>
                Importo totale:{" "}
                <u>
                  {parseFloat(
                    this.state.sanzione.importoIngiunzione / 100
                  ).toFixed(2)}{" "}
                  €
                </u>{" "}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <fieldset className="border p-2">
                {/* <legend className="w-auto" style={{ color: "#4e73df" }}></legend> */}
                <div className="row">
                  <div className="input-group mb-3">
                    <div className="col-sm-4">Numeri di Rata</div>
                    <div className="col-sm-8">
                      <Form.Control
                        as="select"
                        onChange={this.selectNumeroRate.bind(this)}
                      >
                        <option value={0}>Numero Rate</option>
                        {this.optionNumeroRate()}
                      </Form.Control>
                    </div>

                    <div className="container">
                      <br></br>
                      <table class="table table-bordered">
                        {this.state.tableRata.map((rata, index) => {
                          var indiceArrray = parseInt(rata.numeroRata);
                          // console.log(rata.numeroRata)

                          this.giornoCorretta =
                            new Date(rata.dataScandenza).getDate() < 10
                              ? "0" + new Date(rata.dataScandenza).getDate()
                              : new Date(rata.dataScandenza).getDate();
                          this.messeCorretto =
                            new Date(rata.dataScandenza).getMonth() + 2 < 10
                              ? "0" +
                                (new Date(rata.dataScandenza).getMonth() + 2)
                              : new Date(rata.dataScandenza).getMonth() + 2;
                          this.anno = new Date(
                            rata.dataScandenza
                          ).getFullYear();

                          // console.log(this.meseCorretto);

                          this.fullDate =
                            this.giornoCorretta +
                            "/" +
                            this.messeCorretto +
                            "/" +
                            this.anno;
                          return (
                            <>
                              {index === 0 ? (
                                <>
                                  <thead>
                                    <tr>
                                      <th scope="col" className="text-center">
                                        N° Rata
                                      </th>
                                      <th scope="col" className="text-center">
                                        Importo
                                      </th>
                                      <th scope="col" className="text-center">
                                        Data Rata
                                      </th>
                                    </tr>
                                  </thead>
                                </>
                              ) : (
                                ""
                              )}
                              <tbody>
                                <tr>
                                  <td className="text-center">
                                    {rata.numeroRata}
                                  </td>
                                  <td className="text-center">
                                    <div className="input-group">
                                      <div className="input-group-prepend">
                                        <span className="input-group-text">
                                          €
                                        </span>
                                      </div>
                                      <input
                                        id={rata.numeroRata}
                                        className="form-control"
                                        type="number"
                                        value={rata.importo}
                                        onChange={this.inputImportoRata.bind(
                                          this
                                        )}
                                        aria-label="Importo in euro"
                                      />
                                    </div>
                                    {/* {rata.importo < 20.0 ? (
                                      <p className="text-danger">
                                        {rata.importo}€
                                      </p>
                                    ) : (
                                      <p className="text-success">
                                        {rata.importo}€
                                      </p>
                                    )} */}
                                    {this.state.statosingoloImporto[
                                      indiceArrray - 1
                                    ].stato ? (
                                      <p className="text-danger">
                                        Importo inferiore a 20.00 €
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {/* {new Date(rata.dataScandenza).getDate() +
                                      "/" +
                                      new Date(rata.dataScandenza).getMonth() +
                                      "/" +
                                      new Date(
                                        rata.dataScandenza
                                      ).getFullYear()} */}
                                    {this.fullDate}
                                    {/* {geDataFormat(rata.dataScandenza)} */}
                                  </td>
                                </tr>
                              </tbody>
                            </>
                          );
                        })}
                      </table>
                      {/* {this.state.sommaDiTuttiGliImportiRata ===
                      parseFloat(this.importo) ? (
                        <p className="text-center text-success">
                          {parseFloat(this.state.sommaDiTuttiGliImportiRata).toFixed(
                            2
                          )}
                          € / {parseFloat(this.importo).toFixed(2)}€{" "}
                        </p>
                      ) : this.state.sommaDiTuttiGliImportiRata === 0 ? (
                        <></>
                      ) : (
                        <p className="text-center text-danger">
                          {parseFloat(this.state.sommaDiTuttiGliImportiRata).toFixed(
                            2
                          )}
                          € / {parseFloat(this.importo).toFixed(2)}€{" "}
                        </p>
                      )} */}
                      {/* {this.state.sommaDiTuttiGliImportiRata === 0 ? "" : this.state.sommaDiTuttiGliImportiRata === parseFloat(this.importo) ?  (""): ( */}

                      {this.state.creaRata.numeroDiRata <= 0 ? (
                        ""
                      ) : this.state.rateizzaButton ? (
                        <p className="text-center text-danger">
                          L'importo delle rate non corrisponde all'importo
                          sanzione
                        </p>
                      ) : (
                        ""
                      )}
                      {/* {this.state.sommaDiTuttiGliImportiRata ===
                      parseFloat(this.importo) ?  (""): (
                        <p className="text-center text-danger">
                          L'importo delle rate non corrisponde all'importo sanzione
                        </p>
                      )} */}
                      {/* {this.state.sommaDiTuttiGliImportiRata}<p>{parseFloat(this.state.sanzione.importo) / 100}</p> */}
                    </div>
                  </div>
                </div>
                <br></br>
                {/* <div className="row">
                  <div className="input-group mb-3">
                    <div className="col-sm-4">Spese Incasso Rata</div>
                    <div className="input-group-prepend">
                      <span className="input-group-text">€</span>
                    </div>
                    <input
                      className="form-control"
                      type="number"
                      // placeholder={"20.00 / 3.99 Formato Valori"}
                      value={this.state.creaRata.SpeseIncassoRata}
                      onChange={this.importoInCentesimiIncassoRata.bind(this)}
                      // onFocus={this.calcolaRataIncenteimi.bind(this)}
                      aria-label="Importo in euro"
                    />
                  </div>
                </div> */}
              </fieldset>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.AnnullaRateizzaSanzione.bind(this)}
              >
                Annulla
              </Button>
              <Button
                variant="primary"
                onClick={this.ConfermaRateizzaSanzione.bind(this)}
                disabled={this.state.rateizzaButton}
              >
                Rateizza Sanzione
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      </>
    );
  }

  modalRateDaPagare() {
    return (
      <>
        <Modal size="lg" show={this.state.showModalRateDaPagare}>
          <Modal.Header>
            <Modal.Title>Totale delle rate</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>
              <div className="container">
                <table class="table table-bordered">
                  <thead className="text-center">
                    <tr>
                      <th>Numero Rata</th>
                      <th>Importo Da Pagare</th>
                      <th>Scadenza</th>
                      {/* <th>Stato Pagamento</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.rata.rate.map((data) => {
                      const rataDapagare = this.state.rata.rate
                        .map((itm) => itm.stato)
                        .indexOf("daPagare");

                      this.giornoScadenza =
                        new Date(data.dataScandenza).getDate() < 10
                          ? "0" + new Date(data.dataScandenza).getDate()
                          : new Date(data.dataScandenza).getDate();
                      this.meseScadenza =
                        new Date(data.dataScandenza).getMonth() + 1 < 10
                          ? "0" + (new Date(data.dataScandenza).getMonth() + 1)
                          : new Date(data.dataScandenza).getMonth() + 1;
                      this.annoScadenza = new Date(
                        data.dataScandenza
                      ).getFullYear();

                      this.dataScadenzaCorrerra =
                        this.giornoScadenza +
                        "/" +
                        this.meseScadenza +
                        "/" +
                        this.annoScadenza;

                      data.importo = parseFloat(data.importo / 100).toFixed(2);
                      // var arrayDiIMportoRidotto = data.importo.toString().split("");

                      // console.log(arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1]);
                      // if (arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1] === "0") {
                      //   data.importo = data.importo + "0";
                      // }

                      // data.importo = parseFloat(data.importo / 100).toFixed(2);
                      // var importoDaPagare = parseFloat(data.importo / 100).toFixed(2);
                      // console.log(importoDaPagare)
                      return (
                        <>
                          {parseInt(data.numeroRata) === rataDapagare + 1 ? (
                            <tr
                              onClick={() => {
                                // var rowSanzione = JSON.parse(
                                //   sessionStorage.getItem("rowSanzione")
                                // );
                                this.detailIngiunzioneService.getDetailRata(
                                  this.state.dettaglioSanzione.idSanzione,
                                  (result) => {
                                    result.data.rate.map((valore) => {
                                      if (valore.id === data.id) {
                                        // this.state.paga.importoNetto =
                                        //   parseFloat(valore.importo)
                                        this.state.importoDasalvareIDRata =
                                          parseFloat(valore.importo / 100);
                                        // this.setState({importoNetto :  parseFloat(valore.importo)})
                                        this.state.paga.importoNetto =
                                          this.state.importoDasalvareIDRata;
                                        this.state.importoRataInferioreAImportoRata =
                                          valore.importo;
                                        // this.state.paga.codiceTx = "";
                                        this.state.paga.numeroRata = `${parseInt(
                                          data.numeroRata
                                        )}`;

                                        // console.log(this.state.paga)
                                        // console.log(data.id);

                                        this.state.importoRataInferioreAImportoRata =
                                          this.state.importoRataInferioreAImportoRata
                                            .toString()
                                            .replace(",", "");
                                        if (
                                          parseFloat(
                                            this.state.paga.importoNetto * 100
                                          ) <
                                          parseFloat(
                                            this.state
                                              .importoRataInferioreAImportoRata
                                          )
                                        ) {
                                          this.setState({
                                            importoInferiroDellaSanzioneDiUnPagamento: true,
                                          });
                                        } else {
                                          if (
                                            this.state.paga.codiceTx &&
                                            this.state.paga.dataContabile &&
                                            this.state.paga.note &&
                                            this.state.paga.tipoPagamento &&
                                            this.state.paga.importoNetto
                                          ) {
                                            this.setState({
                                              importoInferiroDellaSanzioneDiUnPagamento: false,
                                            });
                                          }
                                        }

                                        this.setState({
                                          seIlPagamentoDerivaDaUnaRata: false,
                                          statoSingolaRata: data.stato,
                                          showModalRateDaPagare: false,
                                          showModalPaga: true,
                                        });
                                      }
                                    });
                                  }
                                );

                                // this.state.paga.importoNetto = this.state.importoDasalvareIDRata
                              }}
                              className="table-warning text-center"
                            >
                              <td>{data.numeroRata}</td>
                              <td>
                                {data.importo.toString().replace(".", ",")}€
                              </td>
                              <td>
                                {/* {new Date(
                                  data.dataScandenza
                                ).toLocaleDateString()} */}
                                {this.dataScadenzaCorrerra}
                              </td>
                              {/* <td>{data.stato}</td> */}
                            </tr>
                          ) : (
                            <tr
                              onClick={() => {
                                if (data.stato === "pagata") {
                                  this.detailIngiunzioneService.dettaglioDiUnPagameto(
                                    this.state.dettaglioSanzione.numeroSanzione,
                                    data.id,
                                    (result) => {
                                      if (result.status === 200) {
                                        this.setState({ paga: result.data });

                                        // console.log(result.data);
                                      } else {
                                        // console.log("errorrrrrre");
                                      }
                                    }
                                  );

                                  this.setState({
                                    showModalPaga: true,
                                    showModalRateDaPagare: false,
                                    statoSingolaRata: data.stato,
                                  });
                                }
                              }}
                              className={
                                data.stato === "pagata"
                                  ? " table-success text-center"
                                  : "table-danger text-center"
                              }
                            >
                              <td>{data.numeroRata}</td>
                              {/* <td>{data.importo + "00"/ 100} €</td> */}
                              <td>
                                {data.importo.toString().replace(".", ",")}€
                              </td>
                              <td>
                                {/* {new Date(
                                  data.dataScandenza
                                ).toLocaleDateString()} */}
                                {this.dataScadenzaCorrerra}
                              </td>
                              {/* <td>{data.stato}</td> */}
                            </tr>
                          )}
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.AnnullaPagaRata.bind(this)}
            >
              Annulla
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
  AnnullaPagaRata() {
    this.setState({ showModalRateDaPagare: false });
  }

  confermaPaga() {
    //this.setState({loading: true});

    this.state.paga.numeroSanzione = this.state.sanzione.numeroSanzione;

    // console.log(this.state.paga)

    // if (
    //   this.state.paga.importoNetto.toString().includes(",") ||
    //   this.state.paga.importoNetto.toString().includes(".")
    // ) {
    //   if (this.state.paga.importoNetto.toString().includes(",")) {
    //     this.state.paga.importoNetto = this.state.paga.importoNetto
    //       .toString()
    //       .replace(",", "");
    //   }
    //   if (this.state.paga.importoNetto.toString().includes(".")) {
    //     this.state.paga.importoNetto = this.state.paga.importoNetto
    //       .toString()
    //       .replace(".", "");
    //   }
    //   this.state.paga.importoNetto = parseInt(this.state.paga.importoNetto);
    // } else {
    //   this.state.paga.importoNetto = parseInt(
    //     this.state.paga.importoNetto * 100
    //   );
    // }

    if (this.state.paga.importoNetto.toString().includes(".")) {
      var importointero = this.state.paga.importoNetto
        .toString()
        .replace(".", "");
    }
    if (this.state.paga.importoNetto.toString().includes(",")) {
      var importointero = this.state.paga.importoNetto
        .toString()
        .replace(",", "");
    }

    if (
      this.state.paga.importoNetto.toString().includes(".") ||
      this.state.paga.importoNetto.toString().includes(",")
    ) {
      this.state.paga.importoNetto = parseFloat(importointero);
    } else {
      this.state.paga.importoNetto = parseFloat(importointero * 100);
    }
    this.setState({
      loadingButton:true,
      confermaUlteriorreDiunPagamento:true,
    })
    this.detailIngiunzioneService.pagaSanzioneORata(
      this.state.paga,
      this.state.dettaglioSanzione.idSanzione,
      7,
      (result) => {
        this.setState({
          loadingButton:false,
          showModalPaga:false,
        })
        // console.log(result.status);
        if (result) {
          toast.success(result, {
            position: toast.POSITION.TOP_RIGHT,
          });

          // window.location.reload();
          // console.log(this.state.rata.rate);
          if (
            this.state.rata.rate.length === parseInt(this.state.paga.numeroRata)
          ) {
            this.state.paga.codiceTx = "";
            this.state.paga.dataContabile = getFormatOraInput(new Date());
            this.state.paga.importoNetto = "";
            this.state.paga.note = "";
            this.state.paga.numeroRata = "";
            this.state.paga.tipoPagamento = "";
            this.state.bloccoTastiAlconfermaPagamento = false;
            this.state.confermaUlteriorreDiunPagamento = true;
            this.props.history.push("/ingiunzioni");
          } else {
            window.location.reload();
          }
          if (this.state.paga.numeroRata === "") {
            this.state.paga.codiceTx = "";
            this.state.paga.dataContabile = getFormatOraInput(new Date());
            this.state.paga.importoNetto = "";
            this.state.paga.note = "";
            this.state.paga.numeroRata = "";
            this.state.paga.tipoPagamento = "";
            this.state.bloccoTastiAlconfermaPagamento = false;
            this.state.confermaUlteriorreDiunPagamento = true;
            this.props.history.push("/ingiunzioni");
          }
        } else {
          toast.error("Il pagamento non è andato a buon fine", {
            position: toast.POSITION.TOP_RIGHT,
          });
          this.state.paga.codiceTx = "";
          this.state.paga.dataContabile = getFormatOraInput(new Date());
          this.state.paga.importoNetto = "";
          this.state.paga.note = "";
          this.state.paga.numeroRata = "";
          this.state.paga.tipoPagamento = "";
          this.state.bloccoTastiAlconfermaPagamento = false;
          this.state.confermaUlteriorreDiunPagamento = true;
        }
      },
      ()=>{
        this.state.paga.codiceTx = "";
        this.state.paga.dataContabile = getFormatOraInput(new Date());
        this.state.paga.importoNetto = "";
        this.state.paga.note = "";
        this.state.paga.numeroRata = "";
        this.state.paga.tipoPagamento = "";
        this.state.bloccoTastiAlconfermaPagamento = false;
        this.state.confermaUlteriorreDiunPagamento = true;
      }
    );

    // alert("Funzionalità in sviluppo... pagatattata");
  }
  annullaPaga() {
    this.state.paga.codiceTx = "";
    this.state.paga.dataContabile = getFormatOraInput(new Date());
    this.state.paga.importoNetto = "";
    this.state.paga.note = "";
    this.state.paga.numeroRata = "";
    this.state.paga.tipoPagamento = "";
    this.state.bloccoTastiAlconfermaPagamento = false;
    this.state.confermaUlteriorreDiunPagamento = true;
    this.setState({ showModalPaga: false });
  }

  modalPagaIngiunzione() {
    return (
      <Modal show={this.state.showModalPaga}>
        <Modal.Header>
          <Modal.Title>
            {this.state.statoSingolaRata === "daPagare"
              ? "Paga Rata"
              : this.state.statoSingolaRata === "pagata"
              ? "Rata Pagata"
              : "Paga Ingiunzione"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.statoSingolaRata === "pagata" ? (
            <>
              <Col>
                Data Contabile
                <input
                  className="form-control"
                  type="text  "
                  disabled={true}
                  //placeholder="GG/MM/YYYY"
                  value={new Date(
                    this.state.paga.dataContabile
                  ).toLocaleDateString(undefined, {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                  })}
                  onChange={this.changeTextDataContabile.bind(this)}
                ></input>
              </Col>
              <Col>
                Tipo Pagamento
                <input
                  className="form-control"
                  type="text  "
                  disabled={true}
                  value={this.state.paga.tipoPagamento}
                ></input>
                {/* <Form.Control as="select" disabled={true}> */}
                {/* <option>Select Tipo Pagamento</option> */}
                {/* <option value="1">Iban</option> */}
                {/* <option value="2">Conto Postale</option> */}
                {/* <option value="3">Contanti</option> */}
                {/* <option value={this.state.paga.tipoPagamento}>{this.state.paga.tipoPagamento}</option> */}
                {/* </Form.Control> */}
              </Col>
              <Col>
                Importo Netto
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text">€</span>
                  </div>
                  <input
                    disabled={true}
                    className="form-control"
                    type="text"
                    placeholder="Importo"
                    value={parseFloat(
                      this.state.paga.importoNetto / 100
                    ).toFixed(2)}
                    onChange={this.changeTextImportoNetto.bind(this)}
                  ></input>
                </div>
              </Col>
              <Col>
                Codice Transazione
                <input
                  disabled={true}
                  className="form-control"
                  type="text"
                  placeholder="identificativo transazione"
                  value={this.state.paga.codiceTx}
                  onChange={this.changeTextCodiceTransazione.bind(this)}
                ></input>
              </Col>
              <Row>
                <Col>
                  Note
                  <textarea
                    className="form-control"
                    type="area"
                    disabled={true}
                    placeholder="eventuali note"
                    value={this.state.paga.note}
                    onChange={this.changeTextEventualiNotePagamento.bind(this)}
                    // disabled={this.state.disableInput}
                  ></textarea>
                </Col>
              </Row>
            </>
          ) : this.state.statoSingolaRata === "daPagare" ? (
            <>
              <Col>
                Data Contabile
                <input
                  className="form-control"
                  type="date"
                  disabled={this.state.bloccoTastiAlconfermaPagamento}
                  placeholder="GG/MM/YYYY"
                  value={this.state.paga.dataContabile}
                  onChange={this.changeTextDataContabile.bind(this)}
                ></input>
              </Col>
              <Col>
                Tipo Pagamento
                <Form.Control
                  as="select"
                  disabled={this.state.bloccoTastiAlconfermaPagamento}
                  onChange={this.changeTextTipoPagamento.bind(this)}
                >
                  <option>Tipo Pagamento</option>
                  <option value="Iban">Iban</option>
                  <option value="Conto Postale">Conto Postale</option>
                  <option value="Contanti">Contanti</option>
                  <option value="Pos">Pos</option>
                </Form.Control>
              </Col>
              <Col>
                Importo Netto
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text">€</span>
                  </div>

                  <input
                    className="form-control"
                    type="text"
                    placeholder="Importo"
                    // value={this.state.paga.importoNetto}
                    disabled={this.state.bloccoTastiAlconfermaPagamento}
                    value={this.state.paga.importoNetto}
                    onChange={this.changeTextImportoNetto.bind(this)}
                  ></input>
                </div>
              </Col>
              <Col>
                Codice Transazione
                <input
                  className="form-control"
                  type="text"
                  placeholder="identificativo transazione"
                  value={this.state.paga.codiceTx}
                  disabled={this.state.bloccoTastiAlconfermaPagamento}
                  onChange={this.changeTextCodiceTransazione.bind(this)}
                ></input>
              </Col>
              <Row>
                <Col>
                  Note
                  <textarea
                    className="form-control"
                    type="area"
                    placeholder="eventuali note"
                    value={this.state.paga.note}
                    disabled={this.state.bloccoTastiAlconfermaPagamento}
                    onChange={this.changeTextEventualiNotePagamento.bind(this)}
                    // disabled={this.state.disableInput}
                  ></textarea>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Col>
                Data Contabile
                <input
                  className="form-control"
                  type="date"
                  placeholder="GG/MM/YYYY"
                  value={this.state.paga.dataContabile}
                  disabled={this.state.bloccoTastiAlconfermaPagamento}
                  onChange={this.changeTextDataContabile.bind(this)}
                ></input>
              </Col>
              <Col>
                Tipo Pagamento
                <Form.Control
                  as="select"
                  onChange={this.changeTextTipoPagamento.bind(this)}
                  disabled={this.state.bloccoTastiAlconfermaPagamento}
                >
                  <option value="0">Tipo Pagamento</option>
                  <option value="1">Iban</option>
                  <option value="2">Conto Postale</option>
                  <option value="3">Contanti</option>
                  <option value="4">Pos</option>
                </Form.Control>
              </Col>
              <Col>
                Importo Netto
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text">€</span>
                  </div>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Importo"
                    value={this.state.paga.importoNetto}
                    // disabled={this.state.bloccoTastiAlconfermaPagamento}
                    disabled={true}
                    onChange={this.changeTextImportoNetto.bind(this)}
                  ></input>
                </div>
              </Col>
              <Col>
                Codice Transazione
                <input
                  className="form-control"
                  type="text"
                  placeholder="identificativo transazione"
                  value={this.state.paga.codiceTx}
                  disabled={this.state.bloccoTastiAlconfermaPagamento}
                  onChange={this.changeTextCodiceTransazione.bind(this)}
                ></input>
              </Col>
              <Row>
                <Col>
                  Note
                  <textarea
                    className="form-control"
                    type="area"
                    placeholder="eventuali note"
                    value={this.state.paga.note}
                    disabled={this.state.bloccoTastiAlconfermaPagamento}
                    onChange={this.changeTextNotaPagaSanzione.bind(this)}
                    // disabled={this.state.disableInput}
                  ></textarea>
                </Col>
              </Row>
            </>
          )}
          <br></br>
          {this.state.confermaUlteriorreDiunPagamento === true ? (
            ""
          ) : (
            <div className="text-center">
              <h4>
                Confermi di voler Pagare :{" "}
                {this.state.paga.importoNetto
                  .toString()
                  .replace(".", ",")}{" "}
                €
              </h4>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {this.state.statoSingolaRata === "pagata" ? (
            <>
              <Button variant="secondary" onClick={this.annullaPaga.bind(this)}>
                Chiudi Scheda
              </Button>
            </>
          ) : this.state.confermaUlteriorreDiunPagamento === true ? (
            <>
              <Button variant="secondary" onClick={this.annullaPaga.bind(this)}>
                Annulla
              </Button>
              <Button
                variant="primary"
                // disabled={this.state.importoInferiroDellaSanzioneDiUnPagamento}
                disabled={
                  !(this.state.paga.codiceTx &&
                  this.state.paga.dataContabile &&
                  this.state.paga.note.length >= 5 &&
                  this.state.paga.tipoPagamento !== "0" &&
                  this.state.paga.importoNetto &&
                  !this.state.loadingButton
                )}
                onClick={() => {
                  this.setState({
                    confermaUlteriorreDiunPagamento: false,
                    bloccoTastiAlconfermaPagamento: true,
                  });
                }}
              >
                {this.state.loadingButton ? <LoadSpinner/> : "Paga"}
              </Button>{" "}
            </>
          ) : this.state.statoSingolaRata === "daPagare" ? (
            <>
              <Button variant="secondary" onClick={this.annullaPaga.bind(this)}>
                Annulla
              </Button>
              <Button variant="primary" onClick={this.confermaPaga.bind(this)}>
                Conferma Paga Rata
              </Button>
            </>
          ) : (
            <>
              <Button variant="secondary" onClick={this.annullaPaga.bind(this)}>
                Annulla
              </Button>
              <Button variant="primary" onClick={this.confermaPaga.bind(this)}>
                Conferma Paga Sanzione
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    );
  }

  paga(event) {
    this.setState({ importoNetto: this.state.sanzione.importoIngiunzione });
    // this.setState({importoNetto : parseFloat(this.state.sanzione.importoIngiunzione /100).toString()});
    this.state.idStatoPassagio = parseInt(event.target.id);
    if (this.state.sanzione.statoIng === "Rateizzato") {
      // var rowSanzione = JSON.parse(sessionStorage.getItem("rowSanzione"));
      this.detailIngiunzioneService.getDetailRata(
        this.state.dettaglioSanzione.idSanzione,
        (result) => {
          this.state.rata = result.data;
          if (result.status === 200) {
            this.setState({ showModalRateDaPagare: true });
          } else {
            // console.log("error");
          }
        }
      );
    } else {
      var diff = calculateTimeDifferenceTwoDates(
        new Date(),
        new Date(moment(this.state.dettaglioSanzione.dataDiEmissione,).format("DD/MM/YYYY"))
      );
      var giorniAllaScadenza = parseInt(diff);

      giorniAllaScadenza <= 5
        ? (this.state.dettaglioSanzione.importoRidotto > 0 ?
           this.state.paga.importoNetto = parseFloat(
            this.state.dettaglioSanzione.importoRidotto / 100
          )
            .toFixed(2)
            .toString()
            .replace(".", ",")
            :this.state.paga.importoNetto = parseFloat(
              this.state.sanzione.importoIngiunzione / 100
            )
              .toFixed(2)
              .toString()
              .replace(".", ",") )
        : (this.state.paga.importoNetto = parseFloat(
            this.state.sanzione.importoIngiunzione / 100
          )
            .toFixed(2)
            .toString()
            .replace(".", ","));

      giorniAllaScadenza <= 5
        ? (this.importoUguale = this.state.dettaglioSanzione.importoRidotto)
        : (this.importoUguale = this.state.sanzione.importoIngiunzione);

      if (
        parseFloat(this.state.paga.importoNetto * 100) <
        parseFloat(this.importoUguale / 100)
      ) {
        this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
      } else {
        if (
          this.state.paga.codiceTx &&
          this.state.paga.dataContabile &&
          this.state.paga.note &&
          this.state.paga.tipoPagamento
        ) {
          this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
        }
      }
      this.state.paga.importoNetto.toString().replace(".", ",");

      this.setState({
        showModalPaga: true,
        seIlPagamentoDerivaDaUnaRata: true,
      });
    }
  }

  changeTextDataContabile(event) {
    this.state.paga.dataContabile = event.target.value;
    this.setState({ paga: this.state.paga });
    if (
      this.state.paga.codiceTx &&
      this.state.paga.dataContabile &&
      this.state.paga.note &&
      this.state.paga.tipoPagamento &&
      this.state.paga.importoNetto
    ) {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
    } else {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
    }
  }
  changeTextEventualiNotePagamento(event) {
    this.state.paga.note = capitalizeFirstLetter(event.target.value);
    this.setState({ paga: this.state.paga });
    if (
      this.state.paga.codiceTx &&
      this.state.paga.dataContabile &&
      this.state.paga.note &&
      this.state.paga.tipoPagamento &&
      this.state.paga.importoNetto
    ) {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
    } else {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
    }
  }

  printStatiSanzioneToPdf(numeroSanzione, storicoStati) {
    let filteredStorico = storicoStati.filter((stato) => (
      stato.matricola &&
      (stato.operazione && stato.operazione !== "...") &&
      stato.motivazioneOperazione !== "..."
    ));
    let pdfContent = {
      content: [
        {
          table: {
            heights: 20,
            widths: [110, 380],
            headerRows: 1,
            body: [
              [
                {text: 'Data e matricola', style: 'header'},
                {text: 'Operazione', style: 'header'},
              ],
              ...filteredStorico.map((stato) => {
                return [
                  {
                    text: stato.dataStato + "\n" + stato.oraCambioStato + "\n" + stato.matricola,
                    style: 'body'
                  },
                  {
                    text: stato.operazione + "\n" + (stato.motivazioneOperazione ? stato.motivazioneOperazione : ""),
                    style: 'body'
                  },
                ]
              })
            ]
          }
        }
      ],
      styles: {
        header: {
          fontSize: 13,
          bold: true,
        },
        body: {
          fontSize: 13,
        },
      }
    }
    pdfMake.createPdf(pdfContent).download("Storico " + numeroSanzione + ".pdf");
  }

  render() {
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <>
        <div id="wrapper">
          <Menucustom />
          {this.dettaglioIngiunzione(this)}
          {this.getModalStoricoStatiSanzione()}
          {this.modalInvioEmail()}
          {this.modalAgliAttiScrittoDifensivo()}
          {this.modalPagaIngiunzione()}
          {this.modalRateizzaSanzione()}
          {this.modalRateDaPagare()}
          {this.modalStoricoPagamenti()}
          {/* {this.showBottonScrittoDifensivo()} */}
        </div>
      </>
    );

    return <div>{content}</div>;
  }
}
export default withRouter(Ingiunzione);
